import { RecipientSelectorModal } from './RecipientSelectorModal'

type Props = {
  show: boolean
  onHide: () => void
  onSubmit: (payload: { contactId: string }[]) => Promise<void>
  loading?: boolean
  campaignName?: string
  campaignId?: string
  onBulkAdded?: () => void
}

export const AddTargetModal = ({
  show,
  onHide,
  onSubmit,
  loading,
  campaignId,
  onBulkAdded,
}: Props) => {
  const handleSelectRecipients = async (selectedIds: string[]) => {
    const targets = selectedIds.map((id) => ({ contactId: id }))
    await onSubmit(targets)
    onHide()
  }

  return (
    <RecipientSelectorModal
      show={show}
      onHide={onHide}
      onSave={handleSelectRecipients}
      initialSelectedIds={[]}
      confirmLabel={loading ? 'Adding...' : 'Add targets'}
      campaignId={campaignId}
      onBulkAdded={onBulkAdded}
    />
  )
}
